'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _zoroRequest = require('@alife/zoro-request');

var _zoroRequest2 = _interopRequireDefault(_zoroRequest);

var _zoroClickstat = require('@alife/zoro-clickstat');

var _zoroClickstat2 = _interopRequireDefault(_zoroClickstat);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = require('../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _zoroArms = require('@alife/zoro-arms');

var _zoroArms2 = _interopRequireDefault(_zoroArms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Verification = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Verification, _Component);

    function Verification(props) {
        (0, _classCallCheck3.default)(this, Verification);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Verification.__proto__ || Object.getPrototypeOf(Verification)).call(this, props));

        _this.active = 0;
        _this.isResend = false;
        _this.resendCodeIndex = 0;
        _this.isResendCtr = false;

        props.showAgreement(true);
        _this.eidtNumber = _this.eidtNumber.bind(_this);
        _this.showEmail = _this.showEmail.bind(_this);
        _this.sendVerification = _this.sendVerification.bind(_this);
        _this.resendCode = _this.resendCode.bind(_this);
        _this.state = {
            inputValue: ['', '', '', '', '', ''],
            showNoCode: false, // 展示未收到验证码引导至email注册
            curCount: 59 // 当前倒计时数
        };
        return _this;
    } // 验证码焦点位置

    // 是否重发验证码

    // 重发验证码点击次数

    (0, _createClass3.default)(Verification, [{
        key: 'componentDidMount',
        // 重发验证码是否曝光

        value: function componentDidMount() {
            // 组件中真正被装载之后
            this.countDown();
        }

        // 重新编辑电话号码

    }, {
        key: 'eidtNumber',
        value: function eidtNumber() {
            // 隐藏提示信息
            this.props.getShowCodeTip(false);
            this.props.editNumber();
        }

        // 展示email

    }, {
        key: 'showEmail',
        value: function showEmail() {
            this.props.showEmail();
        }

        /**
         * 验证码输入框改变
         * @param {*} index 当前验证码输入框索引
         */

    }, {
        key: 'inputChange',
        value: function inputChange(index) {
            var value = this['input' + index].value;

            if (/^[0-9]*$/g.test(value)) {
                if (value.length === 1) {
                    if (index < 6) {
                        this.active = index + 1;
                        this.active === 6 ? this.input5.focus() : this['input' + this.active].focus();
                    }
                } else if (value.length === 0) {
                    if (this.active > 0) {
                        if (this.active === 6) {
                            this.active = 4;
                        } else {
                            this.active -= 1;
                        }
                        this['input' + this.active].focus();
                    }
                } else {
                    // 不能在一个输入框输入多个验证码
                    value = value.substr(0, 1);
                }

                if (this.active >= 6) {
                    this.props.getShowCodeTip(false);
                    // 验证码输入完成点击打点
                    this.clickDot({
                        buttonType: 'code_input',
                        objectType: 'input_box'
                    });
                }
            } else {
                value = '';
            }
            var curiInputValue = this.state.inputValue;
            curiInputValue[index] = value;
            this.setState({
                inputValue: curiInputValue
            });
        }

        /**
         * 点击验证码输入框
         * @param {*} index 当前验证码输入框索引
         */

    }, {
        key: 'inputClick',
        value: function inputClick(index) {
            this.active = index;
            this['input' + this.active].focus();
        }

        /**
         * 验证码倒计时
         */

    }, {
        key: 'countDown',
        value: function countDown() {
            var self = this;
            window.clearInterval(this.countDownTimer); // 停止计时器
            // 验证码倒计时
            this.props.getCountDown(true, false);
            self.countDownTimer = window.setInterval(setRemainTime, 1000); // 启动计时器，1秒执行一次
            self.props.countDownTimer(self.countDownTimer);
            // timer处理函数
            function setRemainTime() {
                if (self.state.curCount === 1) {
                    self.props.getCountDown(false, true);
                    window.clearInterval(self.countDownTimer);
                } else {
                    self.setState({
                        curCount: self.state.curCount - 1
                    });
                }
            }
        }

        /**
         * resendClick
         */

    }, {
        key: 'resendClick',
        value: function resendClick() {
            var self = this;
            window.clearInterval(self.countDownTimer); // 停止计时器
        }

        /**
         * 重发验证码
         */

    }, {
        key: 'resendCode',
        value: function resendCode() {
            var self = this;
            window.clearInterval(self.countDownTimer); // 停止计时器
            self.props.getShowCodeTip(false);
            self.setState({
                inputValue: ['', '', '', '', '', ''],
                curCount: 59
            });

            self.resendCodeIndex += 1;

            self.props.isResend(true);
            self.props.sendSMSAjax();

            self.countDown();

            self.active = 0;
            self.input0.focus();
            // 重发验证码点击打点
            self.clickDot({
                buttonType: 'resend_code',
                objectType: 'button'
            });

            // 重发验证码曝光打点
            if (!self.isResendCtr) {
                this.ctrDot({
                    expType: 'resend_code'
                });
                self.isResendCtr = true;
            }
            if (!self.isEmailSuggestion) {
                this.ctrDot({
                    expType: 'register_via_email_suggestion'
                });
                self.isEmailSuggestion = true;
            }
        }

        /**
         * 提交验证码
         * @param {*} inputBtn 输入验证码input框元素
         */

    }, {
        key: 'sendVerification',
        value: function sendVerification() {
            var _this2 = this;

            var self = this;
            var codeInfo = '';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = self.state.inputValue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var val = _step.value;

                    codeInfo += val;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.props.toggleMask(true);
            if (codeInfo && codeInfo.length === 6) {
                (0, _zoroRequest2.default)({
                    url: 'https://login.aliexpress.com/join/PhoneRegisterCheckVerificationCode.htm',
                    type: 'get',
                    cache: false,
                    dataType: 'json',
                    withCredentials: true, // 支持附带详细信息
                    data: {
                        verificationCode: codeInfo,
                        umidToken: this.props.nCf ? this.props.nCf.getUmidToken() : '',
                        uaToken: this.props.nCf ? this.props.nCf.getUA() : '',
                        registerFrom: this.props.registerFrom
                    }
                }).then(function (res) {
                    self.props.toggleMask(false);
                    if (res && res.result) {
                        _this2.props.showPwdTab();
                    } else {
                        // 用户验证码填写错误，立即展示重新获取按钮
                        self.getValidationError(res.codeInfo);

                        if (res.code === 300) {
                            // 验证码错误点击打点
                            self.clickDot({
                                buttonType: 'code_incorrect_error',
                                objectType: 'input_box'
                            });
                        } else if (res.code === 500) {
                            // 验证码为空点击打点
                            self.clickDot({
                                buttonType: 'code_empty_error',
                                objectType: 'input_box'
                            });
                        }
                    }
                }).catch(function (err) {
                    self.props.toggleMask(false);
                    self.props.getShowCodeTip(true, _i18n2.default.UNAVIALABLE_SERVICE);
                    _zoroArms2.default.error(err);
                });
            } else {
                self.props.toggleMask(false);
                // 验证码输入不完整点击校验的情况
                self.getValidationError(_i18n2.default.NOT_CORRECT_CODE);
            }
            // 创建账号点击打点
            self.clickDot({
                buttonType: 'create_account_phone',
                objectType: 'button'
            });
        }

        /**
         * 验证码不通过时处理
         * @param {*} codeTip 展示验证码错误信息
         */

    }, {
        key: 'getValidationError',
        value: function getValidationError(codeTip) {
            var self = this;
            // 用户验证码填写错误，立即展示重新获取按钮
            window.clearInterval(self.countDownTimer); // 停止计时器
            if (self.resendCodeIndex > 2) {
                // 点击resend code大于三次展示引导email注册框
                self.setState({
                    showNoCode: true
                });
            }
            self.props.getCountDown(false, true);
            self.props.getShowCodeTip(true, codeTip);
            // self.setState({
            //     inputValue: ['', '', '', '', '', '']// 清空输入框
            // });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'p',
                    { className: 'code-desc' },
                    _i18n2.default.SEND_TO,
                    '\xA0',
                    _react2.default.createElement(
                        'b',
                        null,
                        this.props.countryCode + ' ' + this.props.phoneValue
                    ),
                    '.'
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'enter-code' },
                    _i18n2.default.VERIFICATION_RECEIVED,
                    '\xA0',
                    _react2.default.createElement(
                        'a',
                        { onClick: this.eidtNumber },
                        _i18n2.default.EDIT_NUMBER
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'verification-code-wrap' },
                    this.state.inputValue.map(function (item, index) {
                        return _react2.default.createElement('input', {
                            className: 'verification-code',
                            key: index,
                            value: item,
                            index: index,
                            onChange: function onChange() {
                                return _this3.inputChange(index);
                            },
                            onClick: function onClick() {
                                return _this3.inputClick(index);
                            },
                            onKeyUp: function onKeyUp() {
                                return _this3.inputClick(index);
                            },
                            autoFocus: index === 0,
                            onFocus: _this3.inputFocus,
                            ref: function ref(e) {
                                _this3['input' + index] = e;
                            }
                        });
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'error-tip', style: { display: this.props.isShowCodeTip ? 'block' : 'none' } },
                        this.props.showCodeTip
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'code-count-down-wrap', style: { display: this.props.showCountDown ? 'block' : 'none' } },
                    '(',
                    _react2.default.createElement(
                        'span',
                        { className: 'code-count-down' },
                        this.state.curCount
                    ),
                    ') ',
                    _i18n2.default.RESEND_CODE
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'resend-code-wrap', style: { display: this.props.showResendCode ? 'block' : 'none' } },
                    _react2.default.createElement(
                        'a',
                        { className: 'resend-code', onClick: this.resendCode },
                        _i18n2.default.RESEND_CODE
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'no-code', style: { display: this.state.showNoCode ? 'block' : 'none' } },
                    _i18n2.default.NO_RECEIVED_CODE,
                    '\xA0',
                    _react2.default.createElement(
                        'a',
                        { className: 'guide-email', onClick: this.showEmail },
                        _i18n2.default.VIA_EMAIL,
                        ' > '
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'edm-box' },
                    this.props.isShowEDM ? _react2.default.createElement('input', { checked: this.props.allowEDM, onChange: function onChange(param) {
                            _this3.props.handleChangeEDM(param);
                        }, type: 'checkbox', id: 'register-edm', name: 'edm-checkbox' }) : '',
                    this.props.isShowEDM ? _react2.default.createElement(
                        'span',
                        null,
                        this.props.textEDM
                    ) : ''
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-box' },
                    _react2.default.createElement(
                        'a',
                        { className: 'submit', onClick: this.sendVerification },
                        _i18n2.default.CREATE_MY_ACCOUNT
                    )
                )
            );
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // 组件卸载时结束异步操作
            window.clearInterval(this.countDownTimer);
        }

        // 曝光打点

    }, {
        key: 'ctrDot',
        value: function ctrDot(arg) {
            _zoroClickstat2.default.ctr({
                expType: arg.expType
            });
        }

        // 点击打点

    }, {
        key: 'clickDot',
        value: function clickDot(arg) {
            _zoroClickstat2.default.buttonClick({
                buttonType: arg.buttonType,
                objectType: arg.objectType
            });
        }
    }]);
    return Verification;
}(_react.Component), _class.propTypes = {
    isShowCodeTip: _propTypes2.default.bool,
    showAgreement: _propTypes2.default.func,
    nCf: _propTypes2.default.object,
    toggleMask: _propTypes2.default.func,
    registerFrom: _propTypes2.default.string,
    showPwdTab: _propTypes2.default.func,
    countryCode: _propTypes2.default.string,
    phoneValue: _propTypes2.default.string,
    showCountDown: _propTypes2.default.bool,
    showCodeTip: _propTypes2.default.string,
    showResendCode: _propTypes2.default.bool,
    showEmail: _propTypes2.default.func,
    editNumber: _propTypes2.default.func,
    getShowCodeTip: _propTypes2.default.func,
    getCountDown: _propTypes2.default.func
}, _temp);
exports.default = Verification;